/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'stretch',
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		display: 'flex',
	},

	id: {
		width: '8%',
		textAlign: 'center',
		borderLeftWidth: 1,
		borderLeftColor: borderColor,
	},

	name: {
		width: '15%',
		textAlign: 'left',
	},

	user: {
		width: '15%',
		textAlign: 'left',
	},

	dateTime: {
		width: '15%',
		textAlign: 'center',
	},

	pipelineChainage: {
		width: '17%',
		textAlign: 'center'
	},

	remarks: {
		width: '15%',
		textAlign: 'left',
	},

	status: {
		width: '15%',
		textAlign: 'center',
	},

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	},
});

const InvoiceTableRow = ({ data }) => {
	const rows = data?.map((item, index) => (
		<View key={index} wrap={false}>
			<View style={styles.row}>
				
				<Text style={[styles.cell, styles.id]}>
					{item?.id ?? 'No Data'}
				</Text>

				<Text style={[styles.cell, styles.name]}>
					{item?.name ?? 'No Data'}
				</Text>

				<Text style={[styles.cell, styles.user]}>
					{item?.user ?? 'No Data'}
				</Text>

				<Text style={[styles.cell, styles.dateTime]}>
					{item?.dateTime ?? 'No Data'}
				</Text>

				<Text style={[styles.cell, styles.pipelineChainage]}>
					{item?.pipelineChainage ?? 'No Data'}
				</Text>

				<Text style={[styles.cell, styles.remarks]}>
					{item?.remarks ?? 'No Data'}
				</Text>

				<Text style={[styles.cell, styles.status]}>
					{item?.status ?? 'No Data'}
				</Text>

			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;